import React from 'react';
import ReactDOM from 'react-dom/client';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RainbowKitProvider, getDefaultConfig } from '@rainbow-me/rainbowkit';
import { mainnet, base, polygon, arbitrum } from 'wagmi/chains';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { PhantomWalletAdapter } from '@solana/wallet-adapter-wallets';
import { clusterApiUrl } from '@solana/web3.js';
import { Toaster } from 'sonner';
import App from './App';
import './index.css';
import '@rainbow-me/rainbowkit/styles.css';
import '@solana/wallet-adapter-react-ui/styles.css';

const queryClient = new QueryClient();

// RainbowKit/Wagmi config
const wagmiConfig = getDefaultConfig({
    appName: 'SW4P Token Storefront',
    appIcon: 'https://cdn.sw4p.io/sw4p/brand/logo-transparent.png',
    projectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || 'demo',
    chains: [mainnet, base, polygon, arbitrum],
    ssr: false,
});

// Solana config
const solanaEndpoint = import.meta.env.VITE_SOLANA_RPC_URL || clusterApiUrl('mainnet-beta');
const solanaWallets = [new PhantomWalletAdapter()];

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <WagmiProvider config={wagmiConfig}>
            <QueryClientProvider client={queryClient}>
                <RainbowKitProvider>
                    <ConnectionProvider endpoint={solanaEndpoint}>
                        <WalletProvider wallets={solanaWallets} autoConnect>
                            <WalletModalProvider>
                                <Toaster position="top-center" richColors />
                                <App />
                            </WalletModalProvider>
                        </WalletProvider>
                    </ConnectionProvider>
                </RainbowKitProvider>
            </QueryClientProvider>
        </WagmiProvider>
    </React.StrictMode>
);
